module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_cuadrada_marco_comida_23.18af59f2.png";